export default __webpack_public_path__ + "static/media/Quiken_Camion-19.42cf23cb.svg";